<template>
<div class="container-base">
  <div class="pages setting">
    <h1>データ・アカウントの削除</h1>
    <p>{{ $site.name }}に入力した下記のデータを削除できます。</p>
    <ul>
      <li>ブラウザに保存されたデータ</li>
      <li>サーバー上のバックアップデータ</li>
      <li>登録したアカウント</li>
    </ul>
    <p>※ 削除を行うと元には戻せませんのでご注意ください</p>

    <div class="setting-item">
      <h2>1. ブラウザに保存されたデータを削除する</h2>
      <p>このブラウザに保存されている{{ $site.name }}のデータを削除します。</p>
      <p>ネットカフェの共用パソコンなど、データを残したくない場合にご利用ください。</p>
      <p>削除するとデータは元に戻せません。必要な場合は事前にバックアップをおすすめします。</p>
      <div class="delete-confirm text-right"
        v-if="!clearLocalStorageConfirmVisible">
        <el-button @click="clearLocalStorageConfirmVisible = true"
          type="danger"><i class="el-icon-delete"></i> ブラウザのデータを削除する</el-button>
      </div>
      <div class="delete-confirm text-right"
        v-else>
        <div style="text-align: right; margin: 0">
          <el-button @click="clearLocalStorageConfirmVisible = false">キャンセル</el-button>
          <el-button @click="clearLocalStorage();"
            type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
          <p>削除すると元には戻せませんのでご注意ください</p>
        </div>
      </div>
    </div>

    <div v-if="$firebase.isAuthenticated" class="setting-item">
      <h2>2. サーバー上のバックアップを削除する</h2>
      <div v-if="backupList.length">
        <p>ログイン中のアカウント：{{ $firebase.user.email }}</p>
        <p>{{ backupList.length }}件のバックアップがあります。</p>
        <div v-if="backupList.length >= 100">
          一度に削除できるのは100件までです。
        </div>
        <div class="delete-confirm text-right"
          v-if="!deleteBackupsConfirmVisible">
          <el-button @click="deleteBackupsConfirmVisible = true"
            type="danger"><i class="el-icon-delete"></i> {{ backupList.length }}件のバックアップを削除する</el-button>
        </div>
        <div class="delete-confirm"
          v-else>
          <div style="text-align: right; margin: 0">
            <el-button @click="deleteBackupsConfirmVisible = false">キャンセル</el-button>
            <el-button @click="deleteBackups();"
              type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
            <p>削除すると元には戻せませんのでご注意ください</p>
          </div>
        </div>
      </div>
      <div v-else-if="backupListLoaded">
        <p>バックアップはありません</p>
      </div>

      <div class="setting-item">
        <h2>3. アカウントを削除する</h2>
        <div v-if="backupList.length">
          <p>アカウントを削除する前に『2. サーバー上のバックアップの削除』を行ってください。</p>
        </div>
        <div v-else-if="backupListLoaded">
          <div class="delete-confirm text-right"
            v-if="!deleteUserConfirmVisible">
            <el-button @click="deleteUserConfirmVisible = true"
              type="danger"><i class="el-icon-delete"></i> {{ $firebase.user.email }} のアカウントを削除する</el-button>
          </div>
          <div class="delete-confirm"
            v-else>
            <div style="text-align: right; margin: 0">
              <el-button @click="deleteUserConfirmVisible = false">キャンセル</el-button>
              <el-button @click="deleteUser();"
                type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
              <p>削除すると元には戻せませんのでご注意ください</p>
            </div>
          </div>
          <div v-if="deleteUserFailed" class="delete-error">
            <p>アカウントの削除に失敗するときは、ログイン情報が古い可能性があります。</p>
            <p>お手数ですが、一度ログアウトし、ログインしなおしてから再度お試しください。</p>
            <div class="text-right">
              <el-button id="google-logout-account-dialog"
              @click="$firebase.signOut();$event.preventDefault()">ログアウト</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-authenticated setting-item">
      <div class="action">
        <p>サーバー上のバックアップ、アカウントの削除にはログインが必要です</p>
        <login-forms />
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import LoginForms from '@/components/LoginForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      deleteBackupsConfirmVisible: false,
      deleteUserConfirmVisible: false,
      deleteUserFailed: null,
      backupListLoaded: false,
      backupList: [],
      backupCount: 0,
      clearLocalStorageConfirmVisible: false
    }
  },
  methods: {
    clearLocalStorage: async function () {
      await this.$clearStorage()
      this.clearLocalStorageConfirmVisible = false
      const length = await this.$lengthOfStorage()
      if (length === 0) {
        this.$message({
          message: 'ブラウザ内のデータを削除しました',
          type: 'success'
        })
      } else {
        this.$message({
          message: 'ブラウザ内のデータを削除に失敗しました:' + length,
          type: 'error'
        })
      }
    },
    loadAllBackupList: async function () {
      if (!this.$firebase.isAuthenticated) {
        return
      }
      const app = this
      app.backupListLoaded = false
      app.backupList = []
      await app.$firebase.getBackupList(null, 100)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            app.backupList.push({
              id: doc.id,
              label: data.label,
              timestamp: data.timestamp,
              type: data.type,
              platform: data.platform
            })
          })
          app.backupListLoaded = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    deleteBackups: async function () {
      try {
        for (const backup of this.backupList) {
          console.log(backup.id)
          await this.$firebase.deleteBackup(backup.id)
        }
      } catch (e) {
        console.error(e)
      }
      this.loadAllBackupList()
    },
    deleteUser: async function () {
      await this.$firebase.user.reload()
      await this.loadAllBackupList()
      await this.deleteBackups()
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      const deleteResult = this.$firebase.deleteUser()
      const app = this
      deleteResult.then(function () {
        app.$message({
          message: 'アカウントの削除に成功しました。ご利用ありがとうございました。',
          type: 'success'
        })
        app.$axios
          .post(app.$varuna.endPoints.deleteUser, formData)
        app.deleteUserConfirmVisible = false
        app.deleteUserFailed = false
        app.$firebase.signOut()
        app.$router.push('/login')
      }).catch(function (error) {
        app.$message({
          message: 'アカウントの削除に失敗しました',
          type: 'error'
        })
        app.deleteUserFailed = true
        console.error(error)
      })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.loadAllBackupList)
    this.loadAllBackupList()
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.loadAllBackupList)
  }
}
</script>
